<template>
    <div class="w-full p-2 flex gap-2 items-center">
        <BadgePill v-for="(answer, index) in question.options.answers" :key="index" class="" color="gray">
            <span>{{ answer.text }}</span>
        </BadgePill>
    </div>
    <div v-if="question.options.order_matters" class="flex gap-2 text-gray-400">
        <IconInfoCircleFilled class="h-4 w-4" /><span>{{ $t('messages.order_matters') }}</span>
    </div>
</template>
<script>
import { IconInfoCircleFilled } from '@tabler/icons-vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'QuestionMultipleAnswerViewOnly',
    components: {
        BadgePill,
        IconInfoCircleFilled,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
